import React from 'react'
import Markdown from 'react-markdown'
import {css} from '@emotion/react'
import Paper from '../../../components/elements/Paper'


export default function DocumentLayout({content}) {
  const styles = {
    root: css`
      display: flex;
      justify-content: center;
    `,
    document: css`
      max-width: 800px;
      min-height: 100%;

      padding: 24px;
      font-size: 1.2em;
      line-height: 1.6;
    `,
  }


  return (
    <div css={styles.root}>
      <Paper css={styles.document}>
        <Markdown components={{
          img(image) {
            const size = image.alt?.match(/\{(\d+)x(\d+)\}/)
            const width = size ? size[1] : null
            const height = size ? size[2] : null
            return (
              <img
                src={image.src}
                width={width}
                height={height}
                alt={image.alt}
              />
            )
          },
        }}>
          {content}
        </Markdown>
      </Paper>
    </div>
  )
}
